"use strict";
"use es6";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.skipUntil = skipUntil;

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _OuterSubscriber2 = require("../OuterSubscriber");

var _subscribeToResult = require("../util/subscribeToResult");

/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */
function skipUntil(notifier) {
  return function (source) {
    return source.lift(new SkipUntilOperator(notifier));
  };
}

var SkipUntilOperator =
/*#__PURE__*/
function () {
  function SkipUntilOperator(notifier) {
    (0, _classCallCheck2.default)(this, SkipUntilOperator);
    this.notifier = notifier;
  }

  (0, _createClass2.default)(SkipUntilOperator, [{
    key: "call",
    value: function call(subscriber, source) {
      return source.subscribe(new SkipUntilSubscriber(subscriber, this.notifier));
    }
  }]);
  return SkipUntilOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */


var SkipUntilSubscriber =
/*#__PURE__*/
function (_OuterSubscriber) {
  (0, _inherits2.default)(SkipUntilSubscriber, _OuterSubscriber);

  function SkipUntilSubscriber(destination, notifier) {
    var _this;

    (0, _classCallCheck2.default)(this, SkipUntilSubscriber);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SkipUntilSubscriber).call(this, destination));
    _this.hasValue = false;
    _this.isInnerStopped = false;

    _this.add((0, _subscribeToResult.subscribeToResult)((0, _assertThisInitialized2.default)(_this), notifier));

    return _this;
  }

  (0, _createClass2.default)(SkipUntilSubscriber, [{
    key: "_next",
    value: function _next(value) {
      if (this.hasValue) {
        (0, _get2.default)((0, _getPrototypeOf2.default)(SkipUntilSubscriber.prototype), "_next", this).call(this, value);
      }
    }
  }, {
    key: "_complete",
    value: function _complete() {
      if (this.isInnerStopped) {
        (0, _get2.default)((0, _getPrototypeOf2.default)(SkipUntilSubscriber.prototype), "_complete", this).call(this);
      } else {
        this.unsubscribe();
      }
    }
  }, {
    key: "notifyNext",
    value: function notifyNext(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
      this.hasValue = true;
    }
  }, {
    key: "notifyComplete",
    value: function notifyComplete() {
      this.isInnerStopped = true;

      if (this.isStopped) {
        (0, _get2.default)((0, _getPrototypeOf2.default)(SkipUntilSubscriber.prototype), "_complete", this).call(this);
      }
    }
  }]);
  return SkipUntilSubscriber;
}(_OuterSubscriber2.OuterSubscriber);